module.exports = __webpack_public_path__ + "static/media/larkin_arbelljpg.352474ae.jpg";